<!-- BUTTONS -->
<div class="row d-flex align-items-center justify-content-center">
    <button (click)="onImportTwilioPhoneNumber()" mat-raised-button style="width: 15%;" class="me-5">
        <mat-icon>download</mat-icon>
        Import
    </button>
    <button *ngIf="!(aiAgent && aiAgent.agentType == outBoundType)" (click)="openTwilioPhoneNumberSelectionDialog()"
        mat-raised-button style="width: 15%;" class="m-5" color="primary">
        <mat-icon>add</mat-icon>
        Buy
    </button>
</div>

<!-- PHONE NUMBER LIST -->
<div class="container h-100 d-flex align-items-center p-5" *ngIf="isLoading">
    <mat-spinner [diameter]="60" [strokeWidth]="3" class="mx-auto"></mat-spinner>
</div>

<div class="row" *ngIf="!isLoading && phoneSettings.length > 0">
    <h1>{{aiAgent ? 'Unassigned' : 'Current'}} phone number list:</h1>
    <div *ngFor="let phone of phoneSettings; let i = index">
        <div class="row mat-elevation-z2 rounded p-2 mb-2">
            <div class="col-6 d-flex flex-column justify-content-center">
                <p class="m-0 p-0"><span class="fw-bold">Phone number:</span>
                    {{phone.phoneNumber}}</p>
                <p class="m-0 p-0"><span class="fw-bold">Type:</span> {{phone.phoneSettingsType}}</p>
                <p *ngIf="!aiAgent" class="m-0 p-0"><span class="fw-bold">Assigned to:</span> {{phone.aiAgent ? phone.aiAgent.name : 'N/A'}}</p>
            </div>

            <div class="col-6 d-flex justify-content-end align-items-center">
                <button mat-raised-button class="me-2" (click)="onUpdateTwilioPhoneNumber(phone)"
                    *ngIf="phone.phoneSettingsType != 'BOUGHT' && !aiAgent">Edit</button>

                <button *ngIf="!aiAgent" mat-raised-button color="warn"
                    (click)="onDeleteTwilioPhoneNumber(phone)">Delete</button>

                <button *ngIf="aiAgent" mat-raised-button color="primary"
                    (click)="onSelectClicked(phone)">Select</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="phoneSettings.length == 0 && !isLoading" class="mt-5">
    <h1 class="fw-light text-center m-0">No phone numbers</h1>
    <h3 class="fw-light text-center m-0">Add or import phone numbers in order to see them</h3>
</div>